import React from "react";
import { GridCell } from "@progress/kendo-react-grid";
import "./cellCustomActions.css";
import { ArrowBtnMobile } from "../../../assets/logos/icons";
import { Tooltip } from "@progress/kendo-react-tooltip";

export default function cellCustomActions({
    setSelectedItem,
    setShowDetails,
    setNameComponentUser,
    iconOneActive,
    IconOneActive, //Active first icon
    iconTwoActive,
    IconTwoActive, //Active two icon
    iconThirdActive,
    IconThirdActive, //Active third icon
    IconFourthActive, //Active fourth icon
    iconFifthActive, //Active fifth icon
    iconTrashActive, // Active trash icon
    labelOneActions, //Label first icon
    labelTwoActions, //Label second icon, first option
    labelTwoActions2, //Label second icon, second option
    labelThirdActions, //Label third icon
    labelFourthActions, //Label fourth icon
    labelFifthActions, //Label fifth icon
    labelTrashActions, //Label trash icon
    styleCol4, //Class to td (col4) from table, especifies width
    activeDialog1, //True to active dialog and false to change page
    btnOpenDialog1, //Function to open dialog in cellAction
    iconOneActiveSelected, //True or false if you use value from array
    iconTwoActiveSelected, //Active one button item, True or false if you use value from array
    showDialogYesNo, //Value true or false, to dialog
    activeDialog2, //Function to open dialog on second btn in cellAction
    btnOpenDialog2, //Function to open dialog on second btn in cellAction
    showDialogYesNo2, //Value true or false, to dialog on second btn,
    paddingBtns, //True or false if want padding between btns
    mobileFunction,
    tooltipTrashIcon, // Trash icon tooltip text
    activeDialogTrash, //True to open dialog and false to change page
    btnOpenDialogTrash, //Function to open dialog on trash icon
    showDialogYesNoTrash, //Value true or false, for dialog on trash icon
    iconOneActiveArr,
    isLocked = false
}) {
    return class extends GridCell {
        handleClick = (dataItem) => {
            return function (e) {
                setSelectedItem(dataItem);
                setNameComponentUser(e.currentTarget.dataset.id);
                setTimeout(() => {
                    setShowDetails(true);
                }, 500)
            };
        };

        render() {
            //Validate with element from array to first action button
            // if (iconOneActiveSelected && iconOneActiveSelected !== "") {
            //     iconOneActive = this.props.dataItem[iconOneActiveSelected];
            // }
            //Validate with element from array to second action button
            if (iconTwoActiveSelected && iconTwoActiveSelected !== "") {
                labelTwoActions = this.props.dataItem[labelTwoActions2];
            }
            return (
                <td
                    className={`${styleCol4} ${this.props.className}`}
                    style={this.props.style}
                    role={"gridcell"}
                    aria-colindex={this.props.ariaColumnIndex}
                    aria-selected={this.props.isSelected}
                    colSpan={this.props.colSpan}
                >
                    <div>
                        <div className="cellActions-containerAvatar">
                            {/* First icon  */}
                            {iconOneActive &&
                                <IconOneActive {...this.props} />
                            }
                            {/* Second icon  */}
                            {iconTwoActive &&
                                <IconTwoActive {...this.props} />
                            }
                            {/* Third icon  */}
                            {iconThirdActive &&
                                <IconThirdActive {...this.props} />
                            }
                            {/* {iconThirdActive && (
                                <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
                                    <button
                                        className="cellActions-btn"
                                        onClick={this.handleClick(this.props.dataItem)}
                                        data-id={labelThirdActions}
                                    >
                                        <p className="cellActions-textBotton">{labelThirdActions}</p>
                                    </button>
                                </div>
                            )} */}

                            {/* Fourth icon  */}
                            {/* <IconFourthActive {...this.props} /> */}
                            {/* {iconFourthActive && (
                                <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
                                    <button
                                        className="cellActions-btn"
                                        onClick={this.handleClick(this.props.dataItem)}
                                        data-id={labelFourthActions}
                                    >
                                        <p className="cellActions-textBotton">{labelFourthActions}</p>
                                    </button>
                                </div>
                            )} */}
                            {/* Fifth icon  */}
                            {iconFifthActive && (
                                <div className={paddingBtns ? "cellActions-containerBtnsDetails-props" : "cellActions-containerBtnsDetails"}>
                                    <button
                                        className="cellActions-btn"
                                        onClick={this.handleClick(this.props.dataItem)}
                                        data-id={labelFifthActions}
                                    >
                                        <p className="cellActions-textBotton">{labelFifthActions}</p>
                                    </button>
                                </div>
                            )}
                        </div>
                        <div
                            className="cellActions-mobileExpanded"
                            onClick={(mobileFunction) ? () => btnOpenDialog1(this.props.dataItem) : this.handleClick(this.props.dataItem)}
                            data-id={labelFourthActions}
                        >
                            <img
                                className="cellActions-icon-arrow"
                                alt={"cellActions-arrow"}
                                src={ArrowBtnMobile}
                            />
                        </div>
                    </div>
                </td>
            );
        }
    };
}
